import React, { useState, useEffect } from "react";

const ScrollNavigation = () => {
  const [currentSection, setCurrentSection] = useState("");

  // Effect to handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      let current = "";

      // Get all sections
      const sections = document.querySelectorAll(".ccbt-box > div");

      // Loop through sections to find the current one
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.pageYOffset >= sectionTop - 60) {
          current = section.getAttribute("id");
        }
      });

      // Set the current section in state
      setCurrentSection(current);
    };

    // Add event listener for scroll
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <div className="course-top-tab">
        <div>
          <button
            className={currentSection === "secti1" ? "active" : ""}
          >
           
          </button>
          <button
            className={currentSection === "section2" ? "active" : ""}
          >
            
          </button>
          <button
            className={currentSection === "section3" ? "active" : ""}
          >
           
          </button>
          {/* Add more buttons as needed */}
        </div>
      </div>

      <div className="ccbt-box">
        <div id="secti1" className="section">
          <h2>Section 1</h2>
          <p>Content for Section 1</p>
        </div>
        <div id="section2" className="section">
          <h2>Section 2</h2>
          <p>Content for Section 2</p>
        </div>
        <div id="section3" className="section">
          <h2>Section 3</h2>
          <p>Content for Section 3</p>
        </div>
        {/* Add more sections as needed */}
      </div>
    </div>
  );
};

export default ScrollNavigation;
